// @ts-nocheck

import { filter } from 'lodash';
import React from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

import useMergeProps from '../../../hooks/useMergeProps';
import Formatter from '../../../i18n/formatter';
import GridsMenuDesktop from '../components/menu/GridsMenuDesktop';
import { getActivePools } from '../selectors/pool';
import Pool from '../states/pool';

const legacySelector = (state, { params }) => {
  const getPoolInfos = ({ poolId, guaranteedAmount, poolEnd }, currentPoolId) => {
    const poolNumber = Pool.getNumber(poolId);
    const poolType = Pool.getType(poolId);
    return {
      poolId,
      poolNumber,
      link: Pool.getLink(poolType, poolNumber),
      guaranty: guaranteedAmount,
      poolType,
      date: Formatter.formatCalendar(poolEnd),
      isFocus: currentPoolId && currentPoolId === poolId,
    };
  };

  const pools = getActivePools(state);
  const openPools = filter(pools, (pool) => Pool.isOpen(pool));

  const { poolTitle: currentPoolTitle } = params;
  const currentPoolId = currentPoolTitle ? Pool.getIdFromUrl(currentPoolTitle) : null;

  return {
    openPools: openPools.map((pool) => getPoolInfos(pool, currentPoolId)),
    connected: state.user.connected,
  };
};

type GridsMenuDesktopContainerProps = {
  className?: string;
};

const GridsMenuDesktopContainer = (ownProps: GridsMenuDesktopContainerProps) => {
  const params = useParams();

  const selectedProps = useSelector((state) => legacySelector(state, { params }));

  const enhancedProps = useMergeProps({ ownProps, selectedProps });

  return <GridsMenuDesktop {...enhancedProps} />;
};

export default GridsMenuDesktopContainer;
